import { __assign } from "tslib";
import { extractFormatterType, formatValue, } from '@keen.io/charts-utils';
export var generateTable = function (data, format) {
    return data.map(function (el) {
        var table = {};
        Object.keys(el).map(function (key) {
            var _a, _b;
            if (format !== null && typeof format === 'object') {
                var formatObj = format && format;
                var formatter = formatObj[key] && formatObj[key];
                table = __assign(__assign({}, table), (_a = {}, _a[key] = {
                    value: formatter ? formatValue(el[key], formatter) : el[key],
                    formatterType: typeof formatter === 'string'
                        ? extractFormatterType(formatter)
                        : undefined,
                }, _a));
                return;
            }
            table = __assign(__assign({}, table), (_b = {}, _b[key] = {
                value: format instanceof Function ? format(el[key]) : el[key],
            }, _b));
            return;
        });
        return table;
    });
};
